import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';
import { brandSecondary } from '../../../styles/colors';
import { shadowLg } from '../../../../web/styles/shadows';

const { fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	cell: {
		fontSize: fontSizes.sm,
		overflow: 'hidden',
		padding: `${SPACE[12]}px`,
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	cellInteractive: {
		':hover': {
			background: brandSecondary,
			color: THEME.colors.primary.contrastText,
		},
		color: brandSecondary,
		cursor: 'pointer',
	},
	columnHeader: {
		background: THEME.colors.background.main,
		color: THEME.colors.text.main,
		fontSize: fontSizes.sm,
		fontWeight: fontWeights.bold,
		padding: `${SPACE[8]}px ${SPACE[12]}px`,
		position: 'sticky',
		textAlign: 'left',
		top: 0,
		zIndex: 1,
	},
	container: {
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderCollapse: 'separate',
		borderRadius: THEME.common.borderRadius,
		borderSpacing: 0,
		minHeight: 100,
		tableLayout: 'fixed',
		width: '100%',
	},
	extraData: {
		background: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		bottom: SPACE[20],
		boxShadow: shadowLg,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
		padding: SPACE[20],
		position: 'absolute',
		right: SPACE[20],
		width: 400,
		zIndex: 5,
	},
	extraDataKey: {
		fontWeight: fontWeights.bold,
	},
	extraDataName: {
		color: THEME.colors.text.main,
		fontSize: fontSizes.xl,
		fontWeight: fontWeights.bold,
	},
	extraDataRow: {
		alignItems: 'center',
		display: 'flex',
		fontSize: fontSizes.sm,
		justifyContent: 'space-between',
	},
	cellDivider: {
		borderTop: `1px solid ${THEME.colors.border.light}`,
	},
});
